import { Alert } from "@/components/atoms";

export const RegistrationRenewalNotice = () => (
  <Alert
    className="mt-2 min-h-0 border border-info px-4 py-2 text-info-dark"
    type="info"
    noIcon
    message={
      <span className="font-normal">
        Registration records can take up to 48 hours to update after payment. If you&apos;ve just paid, please wait before reconfirming.
      </span>
    }
  />
);
